<script lang="ts" setup>
import { onMounted, nextTick } from 'vue';
import hljs from 'highlight.js/lib/core';
import typescript from 'highlight.js/lib/languages/typescript';
import json from 'highlight.js/lib/languages/json';
import csharp from 'highlight.js/lib/languages/csharp';
import 'highlight.js/styles/github-dark.css';

hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('json', json);
hljs.registerLanguage('csharp', csharp);

onMounted(() =>
{
    nextTick(() =>
    {
        document.querySelectorAll('pre code').forEach((block) =>
        {
            hljs.highlightElement(block as HTMLElement);
        });
    });
});
</script>

<template>
    <section class="doc-section">
        <h2>
            {{ $t('[[[Skrypt wydruku dokumentu]]]') }}
        </h2>
        <p><span>{{ $t('[[[Skrypt pozwala wygenerować wydruk w dowolnym formacie za pomocą kodu. Musi zwracać dane w postaci: ]]]') }}</span><b>PrintScriptExportModel</b></p>

        <!-- PRZYKŁADY SKRYPTÓW -->
        <details open>
            <summary>
                <i class="fa-solid fa-code-branch"></i>
                {{ $t('[[[Przykłady skryptów]]]') }}
            </summary>
            <div class="content">
                <div class="code-example">
                    <h4><i class="fa-solid fa-list"></i> {{ $t('[[[Skrypt zwracający przykładowy wydruk]]]') }}</h4>
                    <pre><code class="csharp">var result = new PrintScriptResult()
{
    FileData = data as byte[],
    FileType = "application/pdf",
    Extension = ".pdf"
};

return result;</code></pre>
                </div>
            </div>
        </details>
    </section>
</template>

<style scoped>
.doc-section {
  font-family: "Segoe UI", sans-serif;
  line-height: 1.6;
  color: #222;
}

.doc-section h2 {
  font-size: 1.4rem;
  border-bottom: 2px solid #007acc;
  padding-bottom: 4px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

details {
  margin: 0 0 0.5rem 0;
}

summary {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 1.1rem;
  color: #007acc;
  border-bottom: 1px solid #ddd;
}

summary::-webkit-details-marker {
  display: none;
}

summary::after {
  content: '▸';
  transition: transform 0.2s;
}

details[open] summary::after {
  transform: rotate(90deg);
}

.content {
  padding: 0.75rem 1rem;
  background: #f8f9fb;
  border-left: 4px solid #007acc;
  border-radius: 0 0 6px 6px;
}

.var-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.var-list li {
  margin: 0.2rem 0;
}

pre {
  background: #1e1e1e;
  color: #f8f8f2;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 0.5rem 0 1rem;
}

.code-example h4 {
  margin: 0.4rem 0;
  color: #444;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
</style>
